import { ChangeDetectionStrategy, Component, inject, input, OnInit, output, TemplateRef } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { HeadlineService } from '../headline/headline.service';
import { NgClass } from '@angular/common';
import { HeadlineComponent } from '../headline/headline.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mwe-tooltip-card',
  templateUrl: './tooltip-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HeadlineService],
  imports: [NgClass, HeadlineComponent, NgbTooltip],
})
export class TooltipCardComponent implements OnInit {
  header = input<string>();
  cardClass = input<{ [value: string]: boolean }>();
  isHeaderTitle = input<boolean>();
  content = input<string>();
  iconClass = input<string>();
  hasTooltipBody = input<boolean>();

  isHeaderBold = input<boolean>(false);
  isClickable = input<boolean>(false);
  orangeInfoTooltipText = input<string | TemplateRef<string>>(null);
  disabled = input<boolean>(false);
  textNodeType = input<TextNodeType>('p');

  hasButtons = input<boolean>(true);

  onClick = output();

  private headlineService = inject(HeadlineService);

  ngOnInit() {
    this.headlineService.setReferenceHeadline(this.textNodeType());
  }
}
